// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__iOt2V","title":"FrontImage_title__2VTwV"};